import React from 'react';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';
import Button from 'tailwind-components/Button/Button';
import { PhoneCall } from 'lucide-react';
import { useDispatch } from 'react-redux';
import propTypes from 'prop-types';
import { showAlert } from 'state/actions/site';

export default function PhoneNumberButton({ text, label }) {
  const dispatch = useDispatch();
  const copyText = () => {
    navigator.clipboard.writeText(text);
    dispatch(
      showAlert({ message: `${label} copied to clipboard!`, code: 'success' })
    );
  };

  return (
    <SimpleContainer className='gap-0'>
      <p className='text-base font-semibold m-0'>{label}</p>
      <Button
        variant='transparent'
        size='small'
        fill
        icon={<PhoneCall size={20} className='text-secondary-darkened' />}
        text={text}
        rounded='small'
        className='justify-start cursor-pointer p-0 font-medium'
        noHoverEffects
        onClick={copyText}
      />
    </SimpleContainer>
  );
}

PhoneNumberButton.propTypes = {
  text: propTypes.string.isRequired,
  label: propTypes.string.isRequired
};
